import _ from 'lodash';
import { lsApiService } from 'ls-vue-common';
// eslint-disable-next-line import/no-cycle
import lsTrackService from '@/services/ls-track/ls-track.service';
// eslint-disable-next-line import/no-cycle
import lsOrderService from '@/services/order/order.service';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import getServices from './order-service-lead.helpers';
import {
    ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS,
    ORDER_SERVICE_LEAD__MUTATE_SERVICES_AND_BUDGET,
    ORDER_SERVICE_LEAD__MUTATE_SERVICE,
    ORDER_SERVICE_LEAD__MUTATE_ADDITIONAL_DETAILS,
    ORDER_SERVICE_LEAD__MUTATE_OUT_OF_MARKET_SERVICES,
    ORDER_SERVICE_LEAD__UPDATE_SERVICE,
    ORDER_SERVICE_LEAD__UPDATE_OUT_OF_MARKET,
    ORDER_SERVICE_LEAD__GET_DETAILS,
    ORDER_SERVICE_LEAD__SUBMIT,
    ORDER_SERVICE_LEAD__SUBMIT_LEADSPEDIA,
    ERROR__SET_ERROR,
} from '../types';

const createInitialState = () => ({
    services: [],
    budgets: [],
    outOfMarket: {
        services: [],
        budgets: [],
    },
    loadingStatus: {
        isLoading: false,
        isUpdating: false,
    },
    additionalDetails: {
        notes: '',
        budget: {},
    },
});

export const mutations = {
    [ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS](state, payload) {
        _.assign(state.loadingStatus, payload);
    },

    [ORDER_SERVICE_LEAD__MUTATE_SERVICES_AND_BUDGET](state, { services, budgets }) {
        const orderOfServices = [75, 9, 7, 2, 5, 18];

        // if any additional services are included that aren't in the above list, insert them before 'other/18'
        _.forEach(services, ({ id }) => {
            if (!_.includes(orderOfServices, id)) {
                orderOfServices.splice(orderOfServices.length - 1, 0, id);
            }
        });

        const sortedServices = _.sortBy(services, ({ id }) => _.indexOf(orderOfServices, id));

        // if we have already gotten services array once, do not update
        // them with fresh data on subsequent calls so we can maintain
        // selected states
        if (!_.size(state.services)) {
            _.assign(state.services, sortedServices);
        }

        if (!_.size(state.outOfMarket.services)) {
            // TODO: recurring mowing was not included in the initial leadspedia spec, so we will manually add it here,
            // but submit it as one-time mowing from the component. Will fix in later epic
            const servicesWithRecurringMowing = _.concat(
                [{ id: 75, name: 'Recurring Mowing', str_id: 'mowing_onetime', service_id: 75 }],
                sortedServices
            );
            _.assign(state.outOfMarket.services, servicesWithRecurringMowing);
        }
        _.assign(state.budgets, budgets);
        _.assign(state.outOfMarket.budgets, budgets);
    },

    [ORDER_SERVICE_LEAD__MUTATE_SERVICE](state, { idx, childIdx, payload }) {
        if (_.isNil(childIdx)) {
            _.assign(state.services[idx], payload);
        } else {
            _.assign(state.services[idx].child_services[childIdx], payload);
        }
    },

    [ORDER_SERVICE_LEAD__MUTATE_ADDITIONAL_DETAILS](state, { payload }) {
        _.assign(state.additionalDetails, payload);
    },

    [ORDER_SERVICE_LEAD__MUTATE_OUT_OF_MARKET_SERVICES](state, payload) {
        _.assign(state.outOfMarket.services, payload);
    },
};

export const actions = {
    [ORDER_SERVICE_LEAD__UPDATE_SERVICE]({ commit }, payload) {
        if (!_.isNil(payload.idx)) {
            commit(ORDER_SERVICE_LEAD__MUTATE_SERVICE, payload);
        } else {
            commit(ORDER_SERVICE_LEAD__MUTATE_ADDITIONAL_DETAILS, payload);
        }
    },

    [ORDER_SERVICE_LEAD__UPDATE_OUT_OF_MARKET]({ commit }, payload) {
        commit(ORDER_SERVICE_LEAD__MUTATE_OUT_OF_MARKET_SERVICES, payload.services);
        commit(ORDER_SERVICE_LEAD__MUTATE_ADDITIONAL_DETAILS, payload.additionalDetails);
    },

    [ORDER_SERVICE_LEAD__GET_DETAILS]({ commit, dispatch }, { id }) {
        commit(ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS, {
            isLoading: true,
        });

        return lsApiService
            .request({
                route: `/orders/${id}/service-leads/details`,
            })
            .then(({ data }) => {
                commit(ORDER_SERVICE_LEAD__MUTATE_SERVICES_AND_BUDGET, data);
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            })
            .finally(() => {
                commit(ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS, {
                    isLoading: false,
                });
            });
    },

    [ORDER_SERVICE_LEAD__SUBMIT]({ commit, state, rootState, dispatch }) {
        commit(ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS, {
            isUpdating: true,
        });

        // get all selected services
        const services = getServices({ services: state.services });

        const data = {
            ...rootState.contactInfo,
            notes: state.additionalDetails.notes,
            budget_low: state.additionalDetails.budget.low,
            budget_high: state.additionalDetails.budget.high,
            services,
        };

        return lsApiService
            .request({
                method: 'POST',
                route: `/orders/${rootState.order.id}/service-leads`,
                payload: data,
            })
            .then(() => {
                const page = '/other-service-quote-complete';
                const label = 'lBjpCI7p_mMQhbDNyAM';

                lsTrackService.sendGoogleAnalyticsPageview(page);
                lsTrackService.trackGoogleConversion({
                    id: 957569029,
                    label,
                });

                router.push({ path: '/single-signup/form/thanks' });
                lsOrderService.clearStoredOrderData();
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            })
            .finally(() => {
                commit(ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS, {
                    isUpdating: false,
                });
            });
    },
    [ORDER_SERVICE_LEAD__SUBMIT_LEADSPEDIA]({ commit, rootState, dispatch }, { payload }) {
        commit(ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS, {
            isUpdating: true,
        });

        // get all selected services
        const services = getServices({
            services: payload.services,
            noParentIfChildren: true,
        });

        const { id } = rootState.order;

        const data = {
            ...rootState.contactInfo,
            notes: payload.notes,
            budget_low: payload.budget.low,
            budget_high: payload.budget.high,
            services,
            trusted_form_id: payload.trusted_form_id,
        };

        return lsApiService
            .request({
                method: 'POST',
                route: `/orders/${id}/leadspedia-leads`,
                payload: data,
            })
            .then(() => {
                lsTrackService.sendGoogleAnalyticsPageview('/inactive-zip-quote-complete');
                lsTrackService.trackGoogleConversion({
                    id: 957569029,
                    label: 'XJM0CIqw_2MQhbDNyAM',
                });
                lsTrackService.track({
                    type: 'submitLeadspediaFormSuccess',
                });
                router.push({ path: '/single-signup/form/thanks/out-of-market' });
                lsOrderService.clearStoredOrderData();
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            })
            .finally(() => {
                commit(ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS, {
                    isUpdating: false,
                });
            });
    },
};

export const orderServiceLead = {
    state: createInitialState,
    mutations,
    actions,
};
